export const movies = [
  {
    id: "mv-01",
    title: "星际裂痕",
    type: "movie",
    region: "美国",
    year: 2025,
    genres: ["科幻", "冒险"],
    director: "阿德里安·柯尔",
    cast: ["莱昂·沃克", "艾米莉亚·雷", "诺亚·布莱克"],
    duration: "138分钟",
    rating: 8.7,
    views: 2865400,
    updatedAt: "2025-10-12",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20art%2C%20a%20lone%20astronaut%20silhouette%20facing%20a%20giant%20glowing%20rift%20in%20deep%20space%2C%20deep%20blue%20and%20cyan%20color%20grade%20with%20warm%20amber%20accent%20light%2C%20dramatic%20volumetric%20lighting%2C%20epic%20scale%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=mvposter01&orientation=portrait",
    summary:
      "一场意外开启的时空裂痕将地球推向存亡边缘。宇航员凯恩孤身穿越裂缝，在异星废墟中寻找重启空间站的方法，却发现真正的敌人来自人类自身的选择。",
  },
  {
    id: "mv-02",
    title: "长安旧梦",
    type: "movie",
    region: "中国",
    year: 2024,
    genres: ["古装", "剧情"],
    director: "沈知远",
    cast: ["陆昭明", "苏语晴", "沈云舟"],
    duration: "124分钟",
    rating: 8.4,
    views: 1987300,
    updatedAt: "2025-09-28",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20historical%20movie%20poster%20art%2C%20ancient%20palace%20lanterns%20glowing%20at%20dusk%2C%20a%20scholar%20in%20flowing%20robes%20standing%20before%20a%20grand%20city%20gate%2C%20deep%20blue%20night%20sky%20with%20warm%20amber%20lantern%20light%2C%20ink%20painting%20atmosphere%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=mvposter02&orientation=portrait",
    summary:
      "长安城最繁华的十年里，一位落魄书生与一位宫中乐师相遇于旧梦之中。繁华落尽，他们用一封信写下对故城与故人的全部牵挂。",
  },
  {
    id: "mv-03",
    title: "暗涌追缉",
    type: "movie",
    region: "中国",
    year: 2025,
    genres: ["犯罪", "悬疑"],
    director: "周砚",
    cast: ["郑川", "林未", "高野"],
    duration: "118分钟",
    rating: 8.1,
    views: 1652300,
    updatedAt: "2025-10-08",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20movie%20poster%20art%2C%20rain%20soaked%20night%20city%20street%20with%20neon%20reflections%2C%20a%20detective%20silhouette%20in%20a%20trench%20coat%2C%20deep%20blue%20shadows%20with%20orange%20streetlight%20accents%2C%20moody%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=mvposter03&orientation=portrait",
    summary:
      "连环案件背后隐藏着一条沉默多年的暗线。刑警周野在追查真相的过程中，逐渐发现每一位证人都在守护着自己的秘密。",
  },
  {
    id: "mv-04",
    title: "深海回声",
    type: "movie",
    region: "美国",
    year: 2024,
    genres: ["科幻", "惊悚"],
    director: "海伦·马歇尔",
    cast: ["丹尼尔·福斯特", "佐伊·克莱因"],
    duration: "112分钟",
    rating: 7.8,
    views: 1320900,
    updatedAt: "2025-08-19",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20underwater%20sci-fi%20thriller%20movie%20poster%20art%2C%20deep%20ocean%20trench%20with%20faint%20bioluminescent%20glow%2C%20a%20submersible%20descending%20into%20darkness%2C%20deep%20blue%20abyss%20with%20teal%20light%20ribbons%2C%20eerie%20atmosphere%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=mvposter04&orientation=portrait",
    summary:
      "深海考察队在无人区记录到一段规律的回声信号。随着下潜深度增加，队员们发现声源并非自然形成，而探索本身正在唤醒沉睡的深海。",
  },
  {
    id: "mv-05",
    title: "山野拾光",
    type: "movie",
    region: "中国",
    year: 2023,
    genres: ["剧情", "家庭"],
    director: "何晓岚",
    cast: ["周桂兰", "梁小满", "陈守田"],
    duration: "106分钟",
    rating: 8.6,
    views: 987400,
    updatedAt: "2025-07-14",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20warm%20family%20drama%20movie%20poster%20art%2C%20sunlit%20rice%20terraces%20in%20southern%20Chinese%20mountains%2C%20an%20elderly%20grandmother%20and%20a%20child%20walking%20a%20narrow%20path%2C%20golden%20afternoon%20light%20with%20deep%20blue%20hills%2C%20nostalgic%20tone%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=mvposter05&orientation=portrait",
    summary:
      "城里长大的少女被送回山村与外婆同住，起初充满抵触。一个夏天过去，她在田间地头重新读懂了家人之间沉默却厚实的爱。",
  },
  {
    id: "mv-06",
    title: "极速边缘",
    type: "movie",
    region: "美国",
    year: 2025,
    genres: ["动作", "赛车"],
    director: "马库斯·雷",
    cast: ["泰森·凯恩", "薇拉·蒙特"],
    duration: "129分钟",
    rating: 7.9,
    views: 1745600,
    updatedAt: "2025-10-01",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20action%20racing%20movie%20poster%20art%2C%20a%20sleek%20race%20car%20drifting%20through%20a%20night%20city%20tunnel%2C%20motion%20blur%20streaks%2C%20deep%20blue%20night%20with%20orange%20tail%20light%20trails%2C%20high%20energy%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=mvposter06&orientation=portrait",
    summary:
      "退役车手被卷入一场横跨大陆的地下挑战赛。为了救回被挟持的妹妹，他必须在速度与规则之间做出最危险的选择。",
  },
  {
    id: "mv-07",
    title: "时光邮局",
    type: "movie",
    region: "韩国",
    year: 2024,
    genres: ["爱情", "奇幻"],
    director: "朴恩彩",
    cast: ["李在勋", "金秀妍"],
    duration: "115分钟",
    rating: 8.3,
    views: 1238200,
    updatedAt: "2025-09-05",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20romantic%20fantasy%20movie%20poster%20art%2C%20a%20cozy%20old%20post%20office%20with%20stacks%20of%20letters%20and%20warm%20lamps%2C%20floating%20glowing%20envelopes%20in%20the%20air%2C%20deep%20blue%20evening%20tones%20with%20soft%20amber%20glow%2C%20dreamy%20atmosphere%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=mvposter07&orientation=portrait",
    summary:
      "小镇邮局里有一个只投递旧信的邮箱。青年邮差在整理信件时，发现一封寄给二十年后的自己的信，也由此遇见了改变他一生的人。",
  },
  {
    id: "mv-08",
    title: "雪原孤狼",
    type: "movie",
    region: "中国",
    year: 2024,
    genres: ["动作", "冒险"],
    director: "闵川",
    cast: ["韩靖", "木其格", "白霜"],
    duration: "121分钟",
    rating: 7.6,
    views: 894600,
    updatedAt: "2025-06-22",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20adventure%20movie%20poster%20art%2C%20a%20lone%20hunter%20in%20fur%20coat%20standing%20on%20a%20vast%20snowfield%20at%20blue%20hour%2C%20distant%20snow%20mountains%20and%20a%20wolf%20silhouette%2C%20cold%20deep%20blue%20palette%20with%20faint%20warm%20sunrise%20edge%2C%20epic%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=mvposter08&orientation=portrait",
    summary:
      "护林员在暴雪封山前深入无人雪原寻找失踪的科考队。与一头孤狼的相遇，让他重新理解了荒野中生存与守护的边界。",
  },
  {
    id: "mv-09",
    title: "迷雾之城",
    type: "movie",
    region: "英国",
    year: 2023,
    genres: ["悬疑", "剧情"],
    director: "奥利弗·格兰特",
    cast: ["亚瑟·贝尔", "菲奥娜·里德"],
    duration: "132分钟",
    rating: 8.0,
    views: 1052700,
    updatedAt: "2025-05-30",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20mystery%20drama%20movie%20poster%20art%2C%20a%20foggy%20Victorian%20harbor%20city%20with%20gas%20lamps%20and%20tall%20ships%2C%20a%20figure%20in%20a%20long%20coat%20walking%20a%20cobblestone%20street%2C%20deep%20blue%20mist%20with%20warm%20lamp%20glow%2C%20moody%20cinematic%20lighting%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=mvposter09&orientation=portrait",
    summary:
      "港城常年被海雾笼罩，一起尘封旧案随着一名记者的调查重新浮出水面。真相藏在每个人都不愿提起的那个雾夜。",
  },
  {
    id: "mv-10",
    title: "沙丘信使",
    type: "movie",
    region: "美国",
    year: 2025,
    genres: ["科幻", "史诗"],
    director: "丹尼斯·奥拉",
    cast: ["卡兰·维斯特", "娜蒂亚·洛", "罗斯·艾文"],
    duration: "156分钟",
    rating: 8.9,
    views: 3210800,
    updatedAt: "2025-10-14",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20epic%20sci-fi%20desert%20movie%20poster%20art%2C%20a%20lone%20messenger%20in%20a%20flowing%20cloak%20walking%20across%20towering%20sand%20dunes%20under%20a%20giant%20pale%20moon%2C%20deep%20blue%20sky%20with%20warm%20orange%20sand%20highlights%2C%20grand%20scale%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=mvposter10&orientation=portrait",
    summary:
      "在资源枯竭的沙海星球上，一名信使背负着决定两个部族命运的信物穿越风暴。每一步前行，都在改写这片荒漠的未来。",
  },
  {
    id: "mv-11",
    title: "都市夜食",
    type: "movie",
    region: "日本",
    year: 2024,
    genres: ["喜剧", "美食"],
    director: "森田悠",
    cast: ["小林拓真", "中村绫"],
    duration: "98分钟",
    rating: 7.7,
    views: 763200,
    updatedAt: "2025-07-02",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20food%20comedy%20movie%20poster%20art%2C%20a%20tiny%20late%20night%20ramen%20stall%20in%20a%20narrow%20Tokyo%20alley%2C%20warm%20steam%20and%20hanging%20lanterns%2C%20deep%20blue%20night%20background%20with%20rich%20amber%20food%20glow%2C%20cozy%20inviting%20mood%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=mvposter11&orientation=portrait",
    summary:
      "一间只在凌晨营业的深夜食堂，迎来形形色色的客人。老板用一碗热汤，接住了每个在城市里疲惫又倔强的灵魂。",
  },
  {
    id: "mv-12",
    title: "沉默证词",
    type: "movie",
    region: "韩国",
    year: 2025,
    genres: ["犯罪", "剧情"],
    director: "郑敏赫",
    cast: ["崔道允", "韩率"],
    duration: "126分钟",
    rating: 8.2,
    views: 1184900,
    updatedAt: "2025-09-18",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20crime%20drama%20movie%20poster%20art%2C%20an%20empty%20courtroom%20at%20night%20lit%20by%20cold%20blue%20windows%2C%20a%20single%20stack%20of%20documents%20on%20a%20table%2C%20deep%20blue%20shadows%20with%20a%20thin%20orange%20light%20line%2C%20tense%20cinematic%20atmosphere%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=mvposter12&orientation=portrait",
    summary:
      "一名法医在一桩证据链完整的案件里发现了无法解释的细节。当所有人选择沉默，他决定用自己的方式，让死者最后一次开口。",
  },
  {
    id: "mv-13",
    title: "长夜将明",
    type: "tv",
    region: "中国",
    year: 2025,
    genres: ["年代", "剧情"],
    director: "林之遥",
    cast: ["宋亦承", "周绾", "纪昀"],
    duration: "全42集",
    rating: 8.8,
    views: 2156700,
    updatedAt: "2025-10-11",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20period%20Chinese%20drama%20poster%20art%2C%20a%20figure%20in%20a%20fifties%20coat%20standing%20on%20a%20rainy%20old%20street%20under%20a%20streetlamp%2C%20deep%20blue%20rainy%20night%20with%20warm%20lamp%20glow%2C%20restrained%20emotional%20tone%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=tvposter01&orientation=portrait",
    summary:
      "动荡年代里，一群年轻人以不同的方式守护着心中的秩序与信念。长夜漫长，而他们相信黎明终将到来。",
  },
  {
    id: "mv-14",
    title: "御赐小厨娘",
    type: "tv",
    region: "中国",
    year: 2024,
    genres: ["古装", "喜剧"],
    director: "苏芷",
    cast: ["温梧", "谢无尘"],
    duration: "全36集",
    rating: 8.0,
    views: 1892400,
    updatedAt: "2025-08-26",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20light%20heart%20Chinese%20costume%20drama%20poster%20art%2C%20a%20lively%20young%20cook%20girl%20in%20bright%20hanfu%20holding%20a%20steaming%20dish%20in%20a%20colorful%20palace%20kitchen%2C%20deep%20blue%20evening%20courtyard%20behind%2C%20warm%20amber%20tones%2C%20cheerful%20mood%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=tvposter02&orientation=portrait",
    summary:
      "市井小厨娘因一道菜意外被召入宫。她凭着手艺与胆识在深宫立足，也与冷面侍卫一起破解了一桩桩藏在餐桌背后的悬案。",
  },
  {
    id: "mv-15",
    title: "都市浮生记",
    type: "tv",
    region: "中国",
    year: 2025,
    genres: ["都市", "情感"],
    director: "陆一凡",
    cast: ["程述", "方梨", "许知然"],
    duration: "全40集",
    rating: 7.9,
    views: 1678500,
    updatedAt: "2025-10-05",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20modern%20urban%20Chinese%20drama%20poster%20art%2C%20three%20young%20professionals%20standing%20on%20a%20high%20glass%20balcony%20overlooking%20a%20deep%20blue%20twilight%20city%2C%20warm%20apartment%20window%20lights%2C%20reflective%20calm%20mood%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=tvposter03&orientation=portrait",
    summary:
      "三个合租在同一屋檐下的年轻人，在职场与生活的夹缝中互相扶持。平凡日子里的每一次坚持，都在悄悄改变他们的未来。",
  },
  {
    id: "mv-16",
    title: "迷雾档案",
    type: "tv",
    region: "中国",
    year: 2024,
    genres: ["悬疑", "刑侦"],
    director: "秦朗",
    cast: ["顾清川", "叶芜", "穆沉"],
    duration: "全32集",
    rating: 8.5,
    views: 2034600,
    updatedAt: "2025-09-22",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20crime%20investigation%20drama%20poster%20art%2C%20a%20detective%20studying%20a%20wall%20of%20case%20files%20and%20red%20strings%20in%20a%20dim%20office%2C%20deep%20blue%20shadows%20with%20a%20focused%20warm%20desk%20lamp%2C%20tense%20cinematic%20atmosphere%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=tvposter04&orientation=portrait",
    summary:
      "重案组接手一宗尘封多年的失踪案，线索却指向内部。随着档案被逐页翻开，真相与代价一同浮现。",
  },
  {
    id: "mv-17",
    title: "硅谷风云",
    type: "tv",
    region: "美国",
    year: 2024,
    genres: ["剧情", "商战"],
    director: "格兰特·肖",
    cast: ["伊森·凯尔", "玛雅·雷诺"],
    duration: "全24集",
    rating: 8.1,
    views: 1123700,
    updatedAt: "2025-07-28",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20corporate%20drama%20poster%20art%2C%20a%20glass%20high%20rise%20office%20at%20night%20with%20glowing%20screens%2C%20a%20silhouette%20looking%20out%20over%20a%20deep%20blue%20city%20skyline%2C%20cool%20blue%20tones%20with%20amber%20window%20light%2C%20sharp%20modern%20mood%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=tvposter05&orientation=portrait",
    summary:
      "一家初创公司在一夜之间站上风口，创始人却在资本与理想之间失去平衡。硅谷的灯光很亮，照亮的却不全是初心。",
  },
  {
    id: "mv-18",
    title: "复仇之约",
    type: "tv",
    region: "韩国",
    year: 2025,
    genres: ["惊悚", "剧情"],
    director: "河智媛",
    cast: ["徐准", "白恩星"],
    duration: "全16集",
    rating: 8.3,
    views: 1456900,
    updatedAt: "2025-10-09",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20revenge%20thriller%20drama%20poster%20art%2C%20an%20elegant%20woman%20in%20a%20dark%20coat%20standing%20in%20a%20rainy%20neon%20alley%20holding%20a%20single%20red%20envelope%2C%20deep%20blue%20night%20with%20crimson%20and%20amber%20accents%2C%20intense%20cinematic%20mood%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=tvposter06&orientation=portrait",
    summary:
      "一场看似意外的事故夺走了她的全部，多年后她以全新身份归来。每一步接近真相的靠近，都是一次精心布置的约定。",
  },
  {
    id: "mv-19",
    title: "樱花信笺",
    type: "tv",
    region: "日本",
    year: 2023,
    genres: ["爱情", "治愈"],
    director: "桥本奈绪",
    cast: ["山崎辽", "石川葵"],
    duration: "全12集",
    rating: 8.4,
    views: 987600,
    updatedAt: "2025-04-16",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20healing%20romance%20drama%20poster%20art%2C%20cherry%20blossom%20petals%20drifting%20over%20a%20quiet%20Japanese%20town%20canal%20at%20dusk%2C%20a%20young%20couple%20writing%20letters%20on%20a%20bridge%2C%20soft%20deep%20blue%20evening%20with%20warm%20pink%20and%20amber%20tones%2C%20tender%20atmosphere%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=tvposter07&orientation=portrait",
    summary:
      "小城里一家快要关门的文具店，收藏着许多未曾寄出的信。少女替人代笔写信，也在字里行间慢慢拼起自己的春天。",
  },
  {
    id: "mv-20",
    title: "王冠之影",
    type: "tv",
    region: "英国",
    year: 2024,
    genres: ["历史", "剧情"],
    director: "爱德华·芬奇",
    cast: ["克拉拉·沃伦", "詹姆斯·拜恩"],
    duration: "全20集",
    rating: 8.7,
    views: 1345200,
    updatedAt: "2025-06-11",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20British%20historical%20drama%20poster%20art%2C%20a%20royal%20stone%20hall%20with%20tall%20windows%20and%20a%20glittering%20crown%20on%20a%20table%2C%20a%20regal%20figure%20in%20a%20dark%20gown%20seen%20from%20behind%2C%20deep%20blue%20interiors%20with%20warm%20candlelight%2C%20formal%20atmosphere%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=tvposter08&orientation=portrait",
    summary:
      "王室阴影之下，一场关于权力与忠诚的博弈悄然展开。女王必须在家族秘密与国家利益之间，做出无人理解的抉择。",
  },
  {
    id: "mv-21",
    title: "星海旅人",
    type: "anime",
    region: "日本",
    year: 2025,
    genres: ["科幻", "冒险"],
    director: "新见翔太",
    cast: ["花村遥", "结城凛"],
    duration: "全26集",
    rating: 8.9,
    views: 1623400,
    updatedAt: "2025-10-13",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20anime%20sci-fi%20adventure%20poster%20art%2C%20a%20young%20traveler%20in%20a%20glowing%20suit%20standing%20on%20a%20small%20spaceship%20deck%20surrounded%20by%20star%20fields%20and%20colorful%20nebulae%2C%20deep%20blue%20cosmos%20with%20warm%20amber%20engine%20glow%2C%20wondrous%20atmosphere%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=anposter01&orientation=portrait",
    summary:
      "少年旅人驾驶一艘老旧飞船，沿着一张残缺的星图寻找传说中的故乡。一路上，他遇见的每一个人都藏着一个关于归途的故事。",
  },
  {
    id: "mv-22",
    title: "灵剑山海",
    type: "anime",
    region: "中国",
    year: 2024,
    genres: ["玄幻", "热血"],
    director: "墨白",
    cast: ["青野", "洛河"],
    duration: "全30集",
    rating: 8.2,
    views: 1478200,
    updatedAt: "2025-09-01",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20fantasy%20anime%20poster%20art%2C%20a%20young%20swordsman%20holding%20a%20glowing%20jade%20sword%20on%20a%20floating%20mountain%2C%20giant%20spirit%20beasts%20in%20the%20misty%20distance%2C%20deep%20blue%20mountains%20with%20warm%20golden%20sword%20light%2C%20epic%20atmosphere%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=anposter02&orientation=portrait",
    summary:
      "山海之间有灵气脉纵横，少年携一柄无名灵剑踏上修行之路。他要找的不只是力量，还有被刻意抹去的身世真相。",
  },
  {
    id: "mv-23",
    title: "声生不息·家年华",
    type: "variety",
    region: "中国",
    year: 2024,
    genres: ["音乐", "综艺"],
    director: "综艺制作中心",
    cast: ["群星嘉宾"],
    duration: "全12期",
    rating: 8.6,
    views: 1785600,
    updatedAt: "2025-08-08",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20music%20variety%20show%20poster%20art%2C%20a%20warmly%20lit%20stage%20with%20microphones%20and%20a%20live%20band%2C%20colorful%20spotlights%20and%20floating%20music%20notes%2C%20deep%20blue%20stage%20with%20warm%20amber%20and%20orange%20lights%2C%20celebratory%20atmosphere%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=vaposter01&orientation=portrait",
    summary:
      "一档聚焦经典歌曲重绎的音乐综艺，邀请不同时代的歌手同台。熟悉的旋律被重新唱响，也带回了属于每个人的家年华。",
  },
  {
    id: "mv-24",
    title: "极限挑战之旅",
    type: "variety",
    region: "中国",
    year: 2025,
    genres: ["真人秀", "综艺"],
    director: "综艺制作中心",
    cast: ["常驻嘉宾团"],
    duration: "全10期",
    rating: 7.8,
    views: 1342700,
    updatedAt: "2025-10-06",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20reality%20travel%20show%20poster%20art%2C%20a%20group%20of%20adventurers%20hiking%20across%20a%20mountain%20ridge%20at%20sunrise%2C%20backpacks%20and%20colorful%20flags%2C%20deep%20blue%20morning%20valleys%20with%20warm%20orange%20sunrise%20light%2C%20energetic%20adventurous%20mood%2C%20high%20detail%2C%20no%20text&width=400&height=600&seq=vaposter02&orientation=portrait",
    summary:
      "嘉宾们走出演播厅，深入山川湖海完成一场场真实挑战。在欢笑与汗水之间，记录下最真诚的同行时光。",
  },
];